import React, { Component } from "react";
import Announcements from "../../components/DashboardWidgets/Announcements/Announcements";
import PropTypes from "prop-types";
import LearningPathAssignments from "../../components/DashboardWidgets/LearningPathAssignments/LearningPathAssignments";
import SocialEmbed from "../../components/DashboardWidgets/SocialEmbed/SocialEmbed";
import Resources from "../../components/DashboardWidgets/Resources/Resources";
import { fetchBanners } from "../../redux/actions/learningCenterSettingsActions";
import {
  fetchWidgets,
  updateWidgetsLayout,
  updateWidgets,
  createCustomWidget,
  updateCustomWidget,
  setEditWidgetMode
} from "../../redux/actions/widgetsActions";
import { fetchResources } from "../../redux/actions/learningCenter/resourcesActions";
import { updateCustomer } from "../../redux/actions/customerActions";
import { connect } from "react-redux";
import CalendarWidget from "../../components/DashboardWidgets/Calendar/CalendarWidget";
import Dashboard from "../../views/Dashboard/Dashboard";
import AddWidgetModal from "../../views/Dashboard/AddWidgetModal";
import AwardsWidget from "../../components/DashboardWidgets/Awards/Awards";
import UpcomingIlt from "../../components/DashboardWidgets/UpcomingILT/UpcomingIlt";
import KingsleyPortal from "../../components/DashboardWidgets/KingsleyPortal/KingsleyPortal";
import widgetUtils from "../../utils/widgetUtils";
import CustomWidget from "../../components/DashboardWidgets/CustomWidget/CustomWidget";
import { widgetKeys, viewDashboardWidgets } from "../../constants";
import { defaultBannerImages } from "../../constants";

const widgetRowHeight = 12;
const widgetMargin = 24;
const totalBannerImages = 3;

class LearningCenterDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editWidgetMode: false,
      addWidgetModalOpen: false,
      widgets: [],
      widgetContentHeights: null,
      layout: null,
      modifiedLayout: null
    };
  }

  componentDidMount() {
    const { widgets, widgetContentHeights } = this.props;
    this.props.fetchBanners();
    this.props.fetchWidgets(viewDashboardWidgets.learningCenter);
    this.setState({ widgets }, () => {
      this.setState({
        layout: widgetUtils.getInitialWidgetLayout(
          this.state.widgets,
          widgetContentHeights,
          widgetRowHeight,
          widgetMargin
        )
      });
    });
  }

  componentDidUpdate() {
    const { widgets, widgetContentHeights, widgetStateLoading } = this.props;
    if (
      !widgetStateLoading &&
      (widgets !== this.state.widgets ||
        widgetContentHeights !== this.state.widgetContentHeights)
    ) {
      this.setState(
        { widgets, widgetContentHeights, modifiedLayout: widgets },
        () =>
          this.setState({
            layout: widgetUtils.getInitialWidgetLayout(
              this.state.widgets,
              widgetContentHeights,
              widgetRowHeight,
              widgetMargin
            )
          })
      );
    }
  }

  renderMyCourses() {
    return null; // TODO: Re-implement
  }

  handleOpenAddWidgetModal = () => {
    this.setState({ addWidgetModalOpen: true });
  };

  handleCloseAddWidgetModal = () => {
    this.setState({ addWidgetModalOpen: false });
  };

  handleSaveAddedWidgets = widgets => {
    this.setState({ btnDisabled: true });
    const newAddedWidgetsList = widgets.map(widgetData => {
      const { widgetLayout, ...widgetProps } = widgetData;
      return {
        ...widgetProps,
        ...widgetLayout
      };
    });
    return this.props
      .updateWidgets(newAddedWidgetsList, viewDashboardWidgets.learningCenter)
      .then(res => {
        this.setState({ btnDisabled: false });
        return this.handleCloseAddWidgetModal();
      });
  };

  handleLayoutChange = modifiedLayout => {
    this.setState({ modifiedLayout });
  };

  handleSaveLayout = () => {
    if (this.state.modifiedLayout !== this.state.widgets) {
      const updatedWidgetLayout = this.state.modifiedLayout.map(widget => {
        const { i, ...newWidgetProps } = widget;
        return {
          name: i,
          ...newWidgetProps
        };
      });
      this.props.updateWidgetsLayout(
        updatedWidgetLayout,
        viewDashboardWidgets.learningCenter
      );
    }
  };

  handleSaveCustomWidget = customWidgetData => {
    this.props.createCustomWidget(customWidgetData);
  };

  handleUpdateCustomWidget = customWidgetData => {
    this.props.updateCustomWidget(customWidgetData, "learning_center");
  };

  handleEditWidgetModeChange = editWidgetMode => {
    this.props.setEditWidgetMode(editWidgetMode);
  };
  /**
   * Get the widget for the associated widget key. If the widget type is system,
   * return the standard system widget, else return the custom widget with the widget's custom content
   */
  getWidget = widgetData => {
    let widget = null;
    if (widgetData.widgetType === "system") {
      switch (widgetData.i) {
        case widgetKeys.myAssignments:
          widget = (
            <LearningPathAssignments
              dashboard={viewDashboardWidgets.learningCenter}
            />
          );
          break;
        case widgetKeys.socialMedia:
          widget = (
            <SocialEmbed
              currentUser={this.props.user}
              currentCustomer={this.props.customer}
              updateCustomer={this.props.updateCustomer}
              dashboard={viewDashboardWidgets.learningCenter}
            />
          );
          break;
        case widgetKeys.resources:
          widget = (
            <Resources
              resources={this.props.resources.resourceSections}
              currentUser={this.props.user}
              dashboard={viewDashboardWidgets.learningCenter}
            />
          );
          break;
        case widgetKeys.announcements:
          widget = (
            <Announcements dashboard={viewDashboardWidgets.learningCenter} />
          );
          break;
        case widgetKeys.calendar:
          widget = (
            <CalendarWidget dashboard={viewDashboardWidgets.learningCenter} />
          );
          break;
        case widgetKeys.awards:
          widget = (
            <AwardsWidget dashboard={viewDashboardWidgets.learningCenter} />
          );
          break;
        case widgetKeys.ilt:
          widget = (
            <UpcomingIlt dashboard={viewDashboardWidgets.learningCenter} />
          );
          break;
        case widgetKeys.kingsley:
          widget = (
            <KingsleyPortal
              dashboard={viewDashboardWidgets.learningCenter}
              bgColor={true}
            />
          );
          break;
        default:
          widget = <></>;
          break;
      }
    } else {
      widget = (
        <CustomWidget
          currentUser={this.props.user}
          widgetData={widgetData}
          onUpdateCustomWidget={this.handleUpdateCustomWidget}
          dashboard={viewDashboardWidgets.learningCenter}
        />
      );
    }
    return widget ? <div key={widgetData.i}>{widget}</div> : null;
  };

  getlearningCenterWidgets = layout => {
    return layout.lg.map(widget => this.getWidget(widget));
  };

  render() {
    const { bannerImages, widgets, editWidgetMode } = this.props;
    const { layout } = this.state;

    let currentBannerImages = [
      ...new Array(totalBannerImages)
    ].map((bannerImage, index) =>
      bannerImages && bannerImages[index]
        ? bannerImages[index].imgPath !== "default"
          ? bannerImages[index]
          : defaultBannerImages[index]
        : { imgPath: "" }
    );

    return (
      <React.Fragment>
        {layout && (
          <Dashboard
            editWidgetMode={editWidgetMode}
            onEditWidgetModeChange={this.handleEditWidgetModeChange}
            widgetRowHeight={widgetRowHeight}
            widgetMargin={widgetMargin}
            widgetLayout={layout}
            noBanner={this.props.noBanner}
            bannerImages={currentBannerImages}
            onOpenAddWidgetModal={this.handleOpenAddWidgetModal}
            onSaveLayout={this.handleSaveLayout}
            onLayoutChange={this.handleLayoutChange}
            customizable={
              this.props.user.isAdmin &&
              this.props.user.permissions.silver === false &&
              this.props.user.permissions.validate === false
            }
          >
            {this.getlearningCenterWidgets(layout)}
          </Dashboard>
        )}
        <AddWidgetModal
          widgets={widgets}
          currentUser={this.props.user}
          open={this.state.addWidgetModalOpen}
          onSaveAddedWidgets={this.handleSaveAddedWidgets}
          onSaveCustomWidget={this.handleSaveCustomWidget}
          onClose={this.handleCloseAddWidgetModal}
          btnDisabled={this.state.btnDisabled}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userState.user,
  customer: state.customerState.customer,
  noBanner: state.learningCenterSettingsState.noBanner,
  bannerImages: state.learningCenterSettingsState.bannerImages,
  widgets: state.widgetsState.widgets,
  widgetContentHeights: state.widgetsState.widgetContentHeights,
  widgetStateLoading: state.widgetsState.loading,
  error: state.learningCenterSettingsState.error,
  resources: state.resourcesState,
  editWidgetMode: state.widgetsState.editWidgetMode
});

const mapDispatchToProps = {
  fetchBanners,
  fetchWidgets,
  updateWidgetsLayout,
  updateWidgets,
  updateCustomer,
  createCustomWidget,
  updateCustomWidget,
  fetchResources,
  setEditWidgetMode
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningCenterDashboard);

LearningCenterDashboard.propTypes = {
  imageCarousel: PropTypes.node
};
